import { isArray } from '~/_shared/utils/collections/collections';
import type { ReportTemplate } from '~/exportReport/template/reportTemplate';

export const validateReportTemplate = (report: Partial<ReportTemplate>) => {
  if (!isArray(report.items)) {
    return {
      isValid: false,
      error: 'Missing template items/content',
    };
  }

  for (const item of report.items) {
    if (item.type === 'table') {
      if (!isArray(item.content)) {
        return {
          isValid: false,
          error: 'Table content has incorrect format, should be an array',
        };
      }

      for (const row of item.content) {
        if (row.type === 'data-row' && !row.id) {
          return {
            isValid: false,
            error: 'At least one of the demographic/data-row is missing the ID',
          };
        }
      }
    }
  }

  return {
    isValid: true,
  };
};
